import { config } from 'src/constants';
import { mockRequestHeaders } from 'src/mocks';
import { isCSRUser } from 'src/utils';

const getHttpConfig = () => ({
  headers: {
    'Content-Type': 'application/json',
    iscsruser: isCSRUser(),
    ...(config.isDevEnv ? mockRequestHeaders : {}),
  },
});

const http = {
  get: () => ({
    method: 'GET',
    ...getHttpConfig(),
  }),
  post: (payload) => ({
    method: 'POST',
    ...getHttpConfig(),
    body: JSON.stringify(payload),
  }),
};

export default http;
